
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { BrandVO } from './vo/brand.vo';
import { ProductVO } from '@/views/biz/product/vo/product.vo'
import Products from '@/components/Products.vue'
import CommonUtils from '@/common-utils';

@Component({
  components: {Products}
})
export default class BrandProducts extends Vue {
  // data
  brand: BrandVO = {} as BrandVO;
  @Prop() brandCd!: string;
  //모바일일때
  get isBannerable(): boolean {
    if(this.$isMobile && this.brand.bannerFileUrl) {
      return true;
    } else if(this.brand.bannerFileUrl || this.brand.bannerFileUrl2) {
      return true;
    }
    return false;
  }
  // initialized events
  created(): void {
    // 브랜드 정보(단건)
    axios.get(`/brand/${this.brandCd}`)
    .then((r) => {
      this.brand = r.data as BrandVO;
      CommonUtils.setDocumentTitle([this.brand.brandNm, this.brand.brandEngNm]);
      CommonUtils.setMetaDiscription(this.brand.description);           
    });
  }  
}
